<template>
  <!-- The texts and tabs of a mistake's 实战 / 推荐 / 对比 views (SPEC §6.6): beside the board in the
       replay, under it in practice's 看答案. -->
  <div class="compare">
    <div class="move-line">{{ heading.before }}<span class="mistake">{{ heading.points }}</span>{{ heading.after }}</div>
    <div class="compare-tabs" role="tablist">
      <button type="button" role="tab" class="compare-tab" :class="{ selected: compare.tab === 'actual' }" :aria-selected="compare.tab === 'actual'" @click="$emit('tab', 'actual')">{{ t('compare-tab-actual', { point: compare.c.actual.move }) }}</button>
      <button type="button" role="tab" class="compare-tab" :class="{ selected: compare.tab === 'suggested' }" :aria-selected="compare.tab === 'suggested'" @click="$emit('tab', 'suggested')">{{ t('compare-tab-suggested', { point: compare.c.best.move }) }}</button>
      <button type="button" role="tab" class="compare-tab" :class="{ selected: compare.tab === 'both' }" :aria-selected="compare.tab === 'both'" :disabled="!maps" @click="$emit('tab', 'both')">{{ t('compare-tab-both') }}</button>
      <!-- Anything the page puts beside the tabs (practice's 试下 on a phone). -->
      <slot/>
    </div>
    <div class="compare-what">{{ what }}</div>
    <!-- The legend and what lives or dies: one paragraph that wraps, not a line each. -->
    <div v-if="squares || labels.length" class="compare-legend">
      <template v-if="squares && compare.tab !== 'both'"><span class="square black"></span>{{ t('compare-legend-black') }} <span class="square white"></span>{{ t('compare-legend-white') }}{{ t('compare-legend-step', { n: step, p: compare.c.p - 1 }) }}</template>
      <template v-if="squares && compare.tab === 'both'"><span class="square blue"></span>{{ t('compare-legend-best', { point: compare.c.best.move }) }} <span class="square red"></span>{{ t('compare-legend-played', { point: compare.c.actual.move }) }}</template>
      <template v-for="(l, i) in labels"><span v-if="squares || i > 0" :key="'s' + i" class="separator">；</span><span :key="l" class="compare-label">{{ l }}</span></template>
    </div>
  </div>
</template>

<script>
import { t } from '@/texts';

export default {
  props: {
    // GameReplay's view: { c, tab, board }.
    compare: { type: Object, required: true },
    heading: { type: Object, required: true },
    what: { type: String, required: true },
    labels: { type: Array, required: true },
    // Whether the analysis has territory maps (then 对比 can be chosen), whether the board shows
    // them now, and the step of the view's line.
    maps: { type: Boolean, default: false },
    squares: { type: Boolean, default: false },
    step: { type: Number, default: 0 },
  },

  methods: { t },
};
</script>

<style scoped>
.move-line {
  margin: 6px auto 0;
  color: #595959;
  font-size: 14px;
}

.move-line .mistake {
  color: #f00;
}

.compare-tabs {
  display: flex;
  justify-content: center;
  margin: 8px auto 6px;
}

button.compare-tab {
  width: auto;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #c9a26b;
  border-left: none;
  border-radius: 0;
  background: #fff;
  color: #2c3e50;
  font-size: 15px;
  white-space: nowrap;
}

button.compare-tab:first-child {
  border-left: 1px solid #c9a26b;
  border-radius: 8px 0 0 8px;
}

button.compare-tab:last-child {
  border-radius: 0 8px 8px 0;
}

button.compare-tab:disabled {
  color: #ccc;
  cursor: default;
}

button.compare-tab.selected {
  background: #ffd39a;
}

.compare-what, .compare-legend, .compare-label {
  margin: 2px auto 0;
  color: #595959;
  font-size: 14px;
}

.compare-legend .compare-label { margin: 0; }

/* 试下 beside the tabs (practice on a phone). */
.compare-tabs ::v-deep button.tabs-study {
  width: auto;
  height: 36px;
  margin-left: 10px;
  padding: 0 14px;
  font-size: 15px;
}

.compare-legend .square {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 3px 0 6px;
  vertical-align: -1px;
}

.compare-legend .square.black { background: #000; }
.compare-legend .square.white { background: #fff; border: 1px solid #333; box-sizing: border-box; }
.compare-legend .square.blue { background: #2a7de1; }
.compare-legend .square.red { background: #d0021b; }
</style>
